import { EventEmitter } from 'events'
import Dispatcher from '../dispatcher'
import ActionTypes from '../constants'

const CHANGE = 'CHANGE'

let _state = {
    menu: false
}

class SiteStore extends EventEmitter {
    
    constructor() {
        super()

        Dispatcher.register(this._registerToActions.bind(this))
    }

    _registerToActions(action) {
        switch (action.actionType) {
            case ActionTypes.TOGGLE_MENU:
                this._toggleMenu()
                break;
        }
    }

    _toggleMenu() {
        _state.menu = !_state.menu
        this.emit(CHANGE)
    }

    getMenuState() {
        return _state.menu
    }

    addChangeListener(callback) {
        this.on(CHANGE, callback)
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE, callback)
    }

}

export default new SiteStore();